import { useEffect } from "react";
import { useShallow } from "zustand/shallow";
import { useAdsStore } from "@/stores/ads-store";

const addSlot = "68c3c8a277f8f70f850bc509";

export function BannerBitmedia() {
  const [showBanner, closeAsd] = useAdsStore(
    useShallow((state) => [state.showAds.bannerBoottom, state.closeAds])
  );

  useEffect(() => {
    if (!showBanner) {
      return () => {};
    }
    const hosts = ["cdn.bmcdn6.com"];
    const file = addSlot;

    function loadScript(m = 0) {
      const s = document.getElementsByClassName(addSlot)[0] || null;

      const script = document.createElement("script");
      script.async = true;
      script.src = `https://${
        hosts[m]
      }/js/${file}.js?v=${new Date().getTime()}`;

      script.onerror = () => {
        closeAsd("bannerBoottom", false);

        script.remove();
        if (m + 1 < hosts.length) loadScript(m + 1);
      };

      if (s && s.parentNode) {
        s.parentNode.append(script);
      } else {
        const target =
          document.head || document.body || document.documentElement;
        target.appendChild(script);
      }
      return () => {
        script.remove();
      };
    }

    const sr = loadScript();
    return () => {
      sr();
    };
  }, [closeAsd, showBanner]);

  useEffect(() => {
    function onclick(e: MouseEvent) {
      const target = e.target as HTMLElement;
      if (target && target.classList.contains("bitmedia-sticky-close-btn")) {
        closeAsd("bannerBoottom", false);
      }
    }
    document.addEventListener("click", onclick);

    return () => {
      document.removeEventListener("click", onclick);
    };
  }, [closeAsd]);

  return (
    <div className="w-full h-[123px]">
      <ins
        className={addSlot}
        id={addSlot}
        style={{
          display: "inline-block",
          width: "calc(100% - 8px)",
          height: 100,
        }}
      ></ins>
    </div>
  );
}
